import { render, staticRenderFns } from "./footer-landscape.vue?vue&type=template&id=5433ac99&scoped=true"
import script from "./footer-landscape.vue?vue&type=script&lang=js"
export * from "./footer-landscape.vue?vue&type=script&lang=js"
import style0 from "./footer-landscape.vue?vue&type=style&index=0&id=5433ac99&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5433ac99",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/runner/work/gameclient/gameclient/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('5433ac99')) {
      api.createRecord('5433ac99', component.options)
    } else {
      api.reload('5433ac99', component.options)
    }
    module.hot.accept("./footer-landscape.vue?vue&type=template&id=5433ac99&scoped=true", function () {
      api.rerender('5433ac99', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/footer-landscape.vue"
export default component.exports